var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"layout":"horizontal","width":"800px","wrapClassName":"timetable-modal","footer":null,"destroyOnClose":true},on:{"cancel":_vm.modalClose}},[_c('YxpCalendar',{attrs:{"markDateMore":_vm.markDateMore},on:{"choseDay":_vm.choseDay,"changeMonth":_vm.changeMonth}}),(_vm.todayCourse.length)?_c('div',{staticClass:"today-course"},_vm._l((_vm.todayCourse),function(item){return _c('div',{staticClass:"course-item"},[_c('div',[_c('span',[_vm._v(_vm._s(item.date))]),_c('span',[_vm._v(_vm._s(item.s_time + "~" + item.e_time))]),_c('span',{staticClass:"course_type"},[_vm._v(_vm._s(item.course_type))]),_c('span',[_vm._v(_vm._s(item.classesinfo))])]),_c('div',{staticClass:"courseInterval"},[(
            _vm.enterStatus({
              timecountdown: item.timecountdown,
              s_time: item.s_time,
              e_time: item.e_time,
              pre_in_class: item.config? item.config.pre_in_class : 0,
              after_in_class: item.config? item.config.after_in_class : 0
            }) === -1
          )?[_c('span',{staticClass:"is__over"},[_vm._v("已结束")])]:(
            _vm.enterStatus({
              timecountdown: item.timecountdown,
              s_time: item.s_time,
              e_time: item.e_time,
              pre_in_class: item.config? item.config.pre_in_class : 0,
              after_in_class: item.config? item.config.after_in_class : 0
            }) === 2
          )?[_c('span',{staticClass:"is_notstart"},[_vm._v("未开课")])]:(
            _vm.enterStatus({
              timecountdown: item.timecountdown,
              s_time: item.s_time,
              e_time: item.e_time,
              pre_in_class: item.config? item.config.pre_in_class : 0,
              after_in_class: item.config? item.config.after_in_class : 0
            }) === 1
          )?[_c('span',[_vm._v("未开课")])]:(
            _vm.enterStatus({
              timecountdown: item.timecountdown,
              s_time: item.s_time,
              e_time: item.e_time,
              pre_in_class: item.config? item.config.pre_in_class : 0,
              after_in_class: item.config? item.config.after_in_class : 0
            }) === 0
          )?[_c('a-button',{attrs:{"size":"small","type":"primary","shape":"round"},on:{"click":function($event){return _vm.enterRoom(item)}}},[_vm._v("进入课堂")])]:(
            _vm.enterStatus({
              timecountdown: item.timecountdown,
              s_time: item.s_time,
              e_time: item.e_time,
              pre_in_class: item.config? item.config.pre_in_class : 0,
              after_in_class: item.config? item.config.after_in_class : 0
            }) === 3
          )?[_c('a-button',{attrs:{"disabled":"","size":"small","type":"primary","shape":"round"}},[_vm._v("已过进入时间")])]:_vm._e()],2)])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }